import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error) { //, errorInfo
        //apm.captureError(error);
        console.log(error);
    }

    render() {
        if (this.state.hasError) {
            return 'Something went wrong, this was already reported please refresh the page.';
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
